import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon, ChevronDownIcon } from 'lucide-react';
export function HeroBanner() {
  return <section className="relative min-h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-185">
      {/* Background Image */}
      <div className="absolute inset-0" data-id="element-186">
        <img src="https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=1920&q=80" alt="Majestic Himalayan mountains in Nepal" className="w-full h-full object-cover" data-id="element-187" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" data-id="element-188" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-190">
          <span className="inline-block mb-6 text-[#D4A853] text-sm font-medium tracking-[0.3em] uppercase" data-id="element-191">
            Luxury Himalayan Journeys
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="font-playfair text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6" data-id="element-192">
          Discover Nepal in
          <br data-id="element-193" />
          <span className="italic font-medium" data-id="element-194">Unparalleled Luxury</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto mb-10 font-light leading-relaxed" data-id="element-195">
          Handcrafted journeys through the Himalayas, ancient temples, and
          pristine wilderness — designed for the discerning traveler.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-196">
          <a href="#trips" className="inline-flex items-center px-8 py-4 bg-teal-600 text-white font-medium rounded-full hover:bg-teal-700 transition-all duration-300 shadow-xl shadow-teal-900/30 text-sm tracking-wide" data-id="element-197">
            Explore Our Journeys
          </a>
          <button className="inline-flex items-center gap-3 px-8 py-4 border border-white/40 text-white font-medium rounded-full hover:bg-white/10 transition-all duration-300 text-sm tracking-wide" data-id="element-198">
            <PlayIcon className="w-4 h-4" data-id="element-199" />
            Watch Our Story
          </button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.a href="#about" aria-label="Scroll down" className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors" animate={{
      y: [0, 8, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-200">
        <ChevronDownIcon className="w-6 h-6" data-id="element-201" />
      </motion.a>
    </section>;
}